<template>
  <div>
    <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
          <textarea-input v-model="form.description" :error="form.errors.description" :rows="8" class="pb-6 w-full lg:w-1/2" placeholder="description here.." :label="__('Description')"></textarea-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

      <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
    TextareaInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    category: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.category.name,
        description: this.category.description,
      }),
    }
    //   console.log(this.access)
  },
  methods: {
    update() {
      this.form.put(this.route('asset_category.update', this.category.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this data?')) {
        this.$inertia.delete(this.route('asset_category.destroy', this.category.id))
      }
    },
  },
}
</script>
